import { render, staticRenderFns } from "./zone-left.vue?vue&type=template&id=64c2a54b&scoped=true"
import script from "./zone-left.vue?vue&type=script&lang=js"
export * from "./zone-left.vue?vue&type=script&lang=js"
import style0 from "./zone-left.vue?vue&type=style&index=0&id=64c2a54b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c2a54b",
  null
  
)

export default component.exports